/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LoggerService } from '../../modules/shared/services/logger.service';

export interface GsptDialogResult {
    distance: number;
    direction: 'up' | 'down';
}
@Component({
    selector: 'dash-gis-gspt-dialog',
    templateUrl: './gspt-dialog.component.html',
    styleUrls: [ './gspt-dialog.component.scss' ],
})
export class GsptDialogComponent {
    public gsptForm: UntypedFormGroup;

    constructor(
        private logger: LoggerService,
        private dialogRef: MatDialogRef<GsptDialogComponent, GsptDialogResult>
    ) {
        // build form
        this.gsptForm = new UntypedFormGroup({
            distance: new UntypedFormControl(''),
            direction: new  UntypedFormControl('up', Validators.required),
        });
    }

    public doTrace() {
        if (!this.gsptForm.value['direction']) {
            return false;
        }
        return this.dialogRef.close(this.gsptForm.value as GsptDialogResult);
    }

    public cancel() {
        this.dialogRef.close(null);
    }

}
